<template>
  <div class="plagin-wrapper x-image layout" v-if="(config && config.src && showCms)">
    <template v-if="config.src.pc && !/pc.png$/i.test(config.src.pc)">
      <img
        :class="['show-for-md', (config.action && config.action.type != 'none') || (config.action.preview_pc && config.action.preview_pc == 1) ? 'clickable' : '']"
        :src="config.src.pc" @click="actionHandler(config.action)" @load="onImgLoaded({
    src: config.src.pc,
    type: 'image',
    platform: 'desktop'
  })" alt="Sisley Paris" />
      <template v-if="config.pc_hots">
        <HotItem :hotsitem="config.pc_hots" class="show-for-md" type="pc"></HotItem>
      </template>
    </template>
    <template v-if="config.src.h5 && !/h5.png$/i.test(config.src.h5)">
      <div @click.prevent="actionHandler(config.action)">
        <img class="hide-for-md on-prevent" :src="config.src.h5" @load="onImgLoaded({
    src: config.src.h5,
    type: 'image',
    platform: 'mobile'
  }, $event)" alt="Sisley Paris" />
      </div>
      <template v-if="config.h5_hots">
        <HotItem :hotsitem="config.h5_hots" class="hide-for-md" type="h5"></HotItem>
      </template>
    </template>
  </div>
</template>

<script>
import acitonMixins from "@/utils/action.mixins";
import HotItem from "@/components/HotItem.vue";

export default {
  name: 'XImage',
  mixins: [acitonMixins],
  components: { HotItem },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showCms: false
    };
  },
  mounted() {
    let customer_type = this.config.customer_type || null
    if (!customer_type) {
      this.showCms = true
    } else {
      let level = this.$store.state.userFullInfo && this.$store.state.userFullInfo.original_level ? Number(this.$store.state.userFullInfo.original_level) : 0
      this.showCms = customer_type.includes(String(level))
    }
  },
  methods: {
    onImgLoaded(target) {
      this.$emit("load", target);
    }
  }
}
</script>

<style lang="scss" scoped>
.plagin-wrapper {
  box-sizing: border-box;
  width: 100%;
  position: relative;
  margin-top: -0.5px;

  img {
    width: 100%;
    height: auto;
  }
}
</style>